import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LostJunkService } from './lost-junk.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { SharedService } from '../../../shared/shared.service';

@Component({
  selector: 'app-lost-junk',
  templateUrl: './lost-junk.component.html',
  styleUrls: ['./lost-junk.component.css']
})
export class LostJunkComponent {
  reasonType: 'lost' | 'junk' = 'lost'; // Initialize reasonType with 'lost'
  @Output() successfulSubmission: EventEmitter<any> = new EventEmitter<any>();
  lostjunkForm!: FormGroup;
  submitted = false;
  formData: any;
  leadId: string | undefined;
  // preSalesLostReason: string | undefined;
  isLoading: Subject<boolean> = new Subject<boolean>();
  salesmanagers: any = [];
  masters: any = [];
  filteredProducts: any = [];
  categories: any = [];
  preSalesLostReason: any = [];
  junkReason: any = [];
  selectedProductId: any;
  brandList: any = []
  constructor(
    public dialogRef: MatDialogRef<LostJunkComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private lostJunkService: LostJunkService,
    private toastr: ToastrService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.leadId = this.data.leadId;
    const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');

    if (masters) {
      this.masters = masters;
      this.junkReason = this.masters.junkReason || [];
      this.preSalesLostReason = this.masters.preSalesLostReason || [];
      this.brandList = this.masters?.brand || [];
    }


    this.lostjunkForm = this.fb.group({
      id: [this.leadId],
      stage_id: [''], // No initial value
      lost_reason: ['', [Validators.required]],
      junk_reason: ['', [Validators.required]],
      brand: ['', [Validators.required]],
      model: [''],
      remarks: [''],
    });

    // Listen for changes in both dropdowns
    // Listen for changes in both dropdowns
    this.lostjunkForm.get('lost_reason')?.valueChanges.subscribe(() => {
      this.onDropdownChange('lost_reason');
    });

    this.lostjunkForm.get('junk_reason')?.valueChanges.subscribe(() => {
      this.onDropdownChange('junk_reason');
    });
    this.setForm('lost')
  }

  get f() {
    return this.lostjunkForm.controls
  }

  isDrop: boolean = false;
  setForm(data: any) {
    if (data == 'junk') {
      this.isDrop = false;
      this.lostjunkForm.controls['lost_reason'].disable();
      this.lostjunkForm.controls['junk_reason'].enable();
      this.lostjunkForm.patchValue({ junk_reason: '' });

      //For Brand
      this.lostjunkForm.patchValue({ brand: '' });
      this.lostjunkForm.controls['brand'].disable();
    } else {
      this.isDrop = true;
      this.lostjunkForm.controls['junk_reason'].disable();
      this.lostjunkForm.controls['lost_reason'].enable();
      this.lostjunkForm.patchValue({ lost_reason: '' });
      this.dropReasonId = null;

      // //For Brand
      // this.lostjunkForm.controls['brand'].enable();
      // this.lostjunkForm.patchValue({ brand: '' });
    }
    this.submitted = false;
  }

  onDropdownChange(changedDropdown: string) {
    if (changedDropdown === 'lost_reason') {
      if (this.lostjunkForm.get('lost_reason')?.value) {
        this.lostjunkForm.get('junk_reason')?.reset();
        this.lostjunkForm.patchValue({ stage_id: '7:Drop' });
      }
    } else if (changedDropdown === 'junk_reason') {
      if (this.lostjunkForm.get('junk_reason')?.value) {
        this.lostjunkForm.get('lost_reason')?.reset();
        this.lostjunkForm.patchValue({ stage_id: '5:Junk' });
      }
    }
  }



  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.submitted = true;
    if (!this.lostjunkForm.valid) {
      return;
    } else {
      if (this.isDrop) {
        const formData: any = this.lostjunkForm.value;
        let request = {
          "id": formData.id,
          "stage_id": formData.stage_id,
          "lost_reason": formData.lost_reason,
          "remarks": formData.remarks,
          "brand": formData.brand,
          "model": formData.model
        }
        this.isLoading = new BehaviorSubject<boolean>(true);
        this.lostJunkService.moveToDrop(request).subscribe((response: any) => {
          let responseData = response.body;
          if (responseData.responseCode == 200) {
            this.successfulSubmission.emit();
            this.dialogRef.close(this.formData);
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.success("Lead Moved to Drop successfully!");
            setTimeout(() => {
              this.getMaster()
            },1000)
          } else {
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.error(responseData?.responseMessage);
          }
        }, (err: any) => {
          this.isLoading = new BehaviorSubject<boolean>(false);
        });
      } else {
        const formData: any = this.lostjunkForm.value;

        this.isLoading = new BehaviorSubject<boolean>(true);
        this.lostJunkService.moveToJunk(formData).subscribe((response: any) => {
          let responseData = response.body;
          if (responseData.responseCode == 200) {
            this.successfulSubmission.emit();
            this.dialogRef.close(this.formData);
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.success("Lead Moved to Junk successfully!");

          } else {
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.error(responseData?.responseMessage);
          }
        }, (err: any) => {
          this.isLoading = new BehaviorSubject<boolean>(false);
        });
      }
    }
  }

  dropReasonId: any = null
  newBrandName: any = ''
  onDropChange(event: any) {
    this.dropReasonId = event.target.value.split(':')[0];
    if (this.dropReasonId == 4) {
      this.isAddEnabled = false;
      this.submitted = false;
      this.lostjunkForm.controls['brand'].enable();
      this.lostjunkForm.patchValue({ brand: '' });
    } else {
      this.lostjunkForm.patchValue({ brand: '' });
      this.lostjunkForm.controls['brand'].disable();
    }
    this.newBrandName = '';
  }

  isAddEnabled: boolean = false
  addEnable() {
    this.lostjunkForm.patchValue({ brand: '' });
    this.submitted = false;
    this.isAddEnabled = true;
  }

  closeAdd() {
    this.lostjunkForm.patchValue({ brand: '' });
    this.isAddEnabled = false;
    this.submitted = false;
  }

  saveBrand() {
    if (!this.newBrandName) {
      this.toastr.error('Please enter a brand name!');
    } else {
      this.isAddEnabled = false;
    }
  }


  restrictFirstLetterSpace(event: any) {
    if (event.target.value.length == 0) {
      if (event.code === 'Space') {
        event.preventDefault();
      }
    }
  }

  allwoAlphabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }

  getMaster() {
    this.lostJunkService.getMasters().subscribe((response: any) => {
      let responseData: any = response.body
      if (responseData.responseCode == 200) {
        sessionStorage.setItem('masters', JSON.stringify(responseData.data));
        this.brandList = responseData.data.brand
      }
    })
  }
}
